import React from "react"

// Components
import ToolType from "./ToolType"

const ToolTypes = ({ sections }) => {
  return (
    <div className="ToolTypes">
      <ToolType section={sections.find(s => s.uuid === "toolType_surveys")} />
      <ToolType section={sections.find(s => s.uuid === "toolType_analytics")} />
      <ToolType section={sections.find(s => s.uuid === "toolType_decision")} />
    </div>
  )
}

export default ToolTypes
